module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row for-authors-policies"
  }, [_c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('for-authors-page-side-menu', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('for-authors-ethics-malpractice-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[0].anchor
    }
  }), _vm._v(" "), _c('for-authors-copyright-licensing-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[1].anchor
    }
  }), _vm._v(" "), _c('for-authors-peer-review-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[2].anchor
    }
  }), _vm._v(" "), _c('for-authors-plagerism-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[3].anchor
    }
  }), _vm._v(" "), _c('for-authors-processing-fee-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[4].anchor
    }
  }), _vm._v(" "), _c('for-authors-archiving-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[5].anchor
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078a4fc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-authors/for-authors-policies/ForAuthorsPoliciesPage.vue
// module id = 1381
// module chunks = 1